const descriptionMap = {
  "Registration Fee": "Reg",
  "Security Deposit": "Seq",
  "Admission Kit & Digital Access": "ADA",
};

export const getDescription = (items) => {
  const instMap = {};

  items.forEach((item) => {
    if (item?.installmentNo === 0) {
      instMap[descriptionMap[item.description]] = true;
    } else {
      if (!instMap[`ist-${item.installmentNo}`]) {
        instMap[`ist-${item.installmentNo}`] = true;
      }
    }
  });
  let des = Object.keys(instMap).join(",");
  if (des && des?.length > 29) {
    return des.substring(0, 26) + "...";
  } else {
    return des;
  }
};
